module.exports = __webpack_public_path__ + "static/img/test-bg-1.6de7cbc1.png";